import { types } from './types.js';

export default {
    closeTokenExpired({ commit }) {
        commit(types.CLOSE_TOKEN_EXPIRED, {
            tokenExpired: false,
        });
    },
    openTokenExpired({ commit }) {
        commit(types.OPEN_TOKEN_EXPIRED, {
            tokenExpired: true
        });
    }
}